import { Box, Stack } from "@mui-wrapper";
import { SubjectType } from "@custom-types/base-types";
import { formatSubjectType } from "@utils/data-display";
import { TextWithTooltip } from "@components/common/text-with-tooltip";
import { Text } from "@flat-ui";

interface Props {
  /** Type of the header */
  type: SubjectType;

  /** Name to be shown in header */
  name: string;

  /** React element displayed next to the name, e.g. a status badge */
  nameAdornment?: React.ReactNode;

  /** React element displayed below the main text */
  subheaderElement?: React.ReactNode;
}

/** Generates an information panel with a header and list of properties on left and right */
export function ProfileHeader({
  type,
  name,
  nameAdornment,
  subheaderElement,
}: Props): React.JSX.Element {
  return (
    <Stack
      spacing={1}
      sx={{
        p: "16px 48px",
        maxWidth: "100vw",
        height: "150px",
      }}
    >
      <Text variant="bodyM">{formatSubjectType(type)}</Text>

      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: "center", mb: 1, minWidth: 0 }}
      >
        <Box sx={{ minWidth: 0, overflow: "hidden" }}>
          <TextWithTooltip text={name} customSx={{ fontSize: "24px" }} />
        </Box>
        {nameAdornment && <Box sx={{ flexShrink: 0 }}>{nameAdornment}</Box>}
      </Stack>

      <Box>{subheaderElement}</Box>
    </Stack>
  );
}
